// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const LayoutSidebarRightOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"currentColor","viewBox":"0 0 16 16","focusable":"false"},"children":[{"tag":"path","attrs":{"clip-rule":"evenodd","d":"M2 1L1 2v12l1 1h12l1-1V2l-1-1H2zm0 13V2h7v12H2z","fill-rule":"evenodd"}}]},"name":"layout-sidebar-right","theme":"outlined"};

const LayoutSidebarRightOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={LayoutSidebarRightOutlinedSvg} />;
  LayoutSidebarRightOutlined.displayName = 'LayoutSidebarRightOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(LayoutSidebarRightOutlined);
